import { api } from "@/lib/api";

export const SUPPORT_CATEGORIES = ["Fatturazione", "Problema tecnico", "Email/PEC", "Condomìni", "Altro"];

export const STATUS_META = {
  aperto: { label: "Aperto", cls: "bg-blue-100 text-blue-700" },
  in_lavorazione: { label: "In lavorazione", cls: "bg-amber-100 text-amber-700" },
  risolto: { label: "Risolto", cls: "bg-emerald-100 text-emerald-700" },
  chiuso: { label: "Chiuso", cls: "bg-gray-200 text-gray-600" },
};

export const PRIORITY_META = {
  bassa: { label: "Bassa", cls: "bg-gray-100 text-gray-600" },
  media: { label: "Media", cls: "bg-blue-100 text-blue-700" },
  alta: { label: "Alta", cls: "bg-red-100 text-red-700" },
};

// Numero ticket univoco formattato: 123 -> "#000123"
export const fmtTicketNo = (n) => (n == null ? "" : `#${String(n).padStart(6, "0")}`);

export const fmtDateTime = (iso) => {
  if (!iso) return "";
  try { return new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" }); }
  catch { return (iso || "").replace("T", " ").slice(0, 16); }
};

export const fmtSize = (n) => {
  if (n == null) return "";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${Math.round(n / 1024)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
};

// Carica un file per un ticket di assistenza, ritorna il record allegato
export const uploadSupportFile = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const r = await api.post("/support/attachments/upload", fd);
  return r.data; // { file_id, filename, size, content_type }
};

export const supportFileUrl = (fileId) =>
  `${process.env.REACT_APP_BACKEND_URL}/api/support/attachments/${fileId}/download`;
